import {Suspense} from 'react';
import {lazyWithRetry} from 'src/utils/lazyWithRetry';
import {Outlet} from 'react-router-dom';
// auth
import {AuthGuard} from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import {LoadingScreen} from 'src/components/loading-screen'

const TransportsPage = lazyWithRetry(() => import('src/pages/transports/TransportsPage'));
const TransportPage = lazyWithRetry(() => import('src/pages/transport/TransportPage'));

export const transportsRoutes = [
  {
    path: '/transports',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      {
        index: true,
        element: <TransportsPage />,
      },
      {
        path: ':id',
        element: <TransportPage />,
      },
    ],
  },
];
